function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#E05151"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6414 12.1946L16.104 9.73237C16.4647 9.37125 16.4647 8.78025 16.104 8.41912L15.7755 8.091C15.4144 7.7295 14.8234 7.7295 14.4626 8.091L12 10.5532L9.53736 8.09062C9.17661 7.7295 8.58561 7.7295 8.22449 8.09062L7.89599 8.41875C7.53524 8.77987 7.53524 9.37087 7.89599 9.732L10.3582 12.1942L7.89599 14.6569C7.53524 15.018 7.53524 15.6086 7.89599 15.9697L8.22449 16.2982C8.58561 16.6594 9.17661 16.6594 9.53736 16.2982L12 13.836L14.4626 16.2982C14.8234 16.6594 15.4144 16.6594 15.7755 16.2982L16.104 15.9697C16.4647 15.6086 16.4647 15.018 16.104 14.6569L13.6414 12.1946Z",
  fill: "white"
});

var SvgErplyDeleteColor = function SvgErplyDeleteColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErplyDeleteColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/erply_delete_color.da989121.svg";
export { ForwardRef as ReactComponent };